import api from 'service/api'

const dponetAPI = api.create('dponet')

const show = async (params) => {
  return await dponetAPI.get('/phishing_indicators', { params })
}

const phishingIndicators = {
  show,
}

export default phishingIndicators
